import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment svgIconAsset on Craft_svgIcons_Asset {
    uid
    url
    title
    extension
    altTag
  }
`

export const svgIconsAssets = gql`
  fragment svgIconAsset on svgIcons_Asset {
    uid
    url
    title
    extension
    altTag
  }
`
